import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12bf0058"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Crear alertas", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "fas el-icon-plus" }, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["title"]
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "nameDesc" }
const _hoisted_16 = { class: "name-flex" }
const _hoisted_17 = { class: "name-flex" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "space-top" }, "Notificación de las alertas", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { class: "header-method" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-address-book fas" }, null, -1))
const _hoisted_23 = { style: {"margin-right":"8px"} }
const _hoisted_24 = { style: {"color":"var(--el-text-color-secondary)","font-size":"13px"} }
const _hoisted_25 = { style: {"margin-right":"8px"} }
const _hoisted_26 = { style: {"color":"var(--el-text-color-secondary)","font-size":"13px"} }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-info fas" }, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "¿Cuándo quieres recibir la alerta?", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-info fas" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-info fas" }, null, -1))
const _hoisted_31 = { class: "threshold-item" }
const _hoisted_32 = { class: "label" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-info fas" }, null, -1))
const _hoisted_34 = { class: "threshold-item" }
const _hoisted_35 = { class: "label" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-info fas" }, null, -1))
const _hoisted_37 = { key: 2 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Resumen de la Alerta", -1))
const _hoisted_39 = { style: {"max-width":"600px","margin":"auto","padding":"20px","border":"1px solid #dcdfe6","border-radius":"5px","background-color":"#f9f9f9"} }
const _hoisted_40 = { style: {"margin-bottom":"10px"} }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nombre:", -1))
const _hoisted_42 = { style: {"margin-bottom":"10px"} }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Descripción:", -1))
const _hoisted_44 = { style: {"margin-bottom":"10px"} }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Tipo:", -1))
const _hoisted_46 = {
  key: 0,
  style: {"margin-bottom":"10px"}
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Direciones de correo:", -1))
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { style: {"list-style-type":"none","padding":"0","margin":"0"} }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = {
  key: 1,
  style: {"margin-bottom":"10px"}
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nº de teléfono:", -1))
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { style: {"list-style-type":"none","padding":"0","margin":"0"} }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = {
  key: 2,
  style: {"margin-bottom":"10px","word-break":"normal"}
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Notificación: ", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "space-top" }, "Condiciones", -1))
const _hoisted_59 = { class: "button-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_alert_edit_form_component = _resolveComponent("alert-edit-form-component")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_contact_form_component = _resolveComponent("contact-form-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.currentView === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_el_radio_group, {
            modelValue: _ctx.typeAlert,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.typeAlert) = $event)),
            onChange: _ctx.changeType
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio, {
                label: "absolute",
                size: "large",
                border: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("label.absolute")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_radio, {
                label: "relative",
                size: "large",
                border: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("label.relative")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"]),
          _createVNode(_component_el_form, {
            model: _ctx.alertFormList,
            "label-position": "top",
            ref: "form1",
            rules: _ctx.rules1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, { gutter: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 5 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            prop: "samplingPoint",
                            label: _ctx.$t('label.monitorizationPoint')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.alertFormList.samplingPoint,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.alertFormList.samplingPoint) = $event)),
                                filterable: "",
                                "value-key": "id"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.samplingPoints, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.name,
                                      value: item,
                                      onClick: ($event: any) => (_ctx.putParameters(item))
                                    }, null, 8, ["label", "value", "onClick"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            prop: "parameter",
                            label: _ctx.$t('label.parameter')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.alertFormList.parameter,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.alertFormList.parameter) = $event)),
                                filterable: "",
                                "value-key": "id"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parameterList, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.name,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 4 }, {
                        default: _withCtx(() => [
                          (_ctx.typeAlert === 'absolute')
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                prop: "operator",
                                label: _ctx.$t('label.operator')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.alertFormList.operator,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.alertFormList.operator) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operList, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item,
                                          label: item,
                                          value: item
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"]))
                            : (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 1,
                                prop: "operator",
                                label: _ctx.$t('label.operator')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.alertFormList.operator,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.alertFormList.operator) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operRelative, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item,
                                          label: item,
                                          value: item
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 3 }, {
                        default: _withCtx(() => [
                          (_ctx.typeAlert === 'absolute')
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                prop: "value",
                                label: _ctx.$t('label.value'),
                                rules: [
                { required: true, message: _ctx.$t('error.required') },
                { type: 'number', message: _ctx.$t('error.no_number') },
              ]
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.alertFormList.parameter?.code === 'TMOA')
                                    ? (_openBlock(), _createBlock(_component_el_select, {
                                        key: 0,
                                        modelValue: _ctx.alertFormList.value,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.alertFormList.value) = $event)),
                                        placeholder: ""
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions, (opt) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: opt.value,
                                              label: opt.label + ' (' + opt.value + ')',
                                              value: opt.value
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"]))
                                    : (_openBlock(), _createBlock(_component_el_input, {
                                        key: 1,
                                        modelValue: _ctx.alertFormList.value,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.alertFormList.value) = $event)),
                                        modelModifiers: { number: true },
                                        type: "number"
                                      }, null, 8, ["modelValue"]))
                                ]),
                                _: 1
                              }, 8, ["label", "rules"]))
                            : (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 1,
                                prop: "value",
                                label: '%',
                                rules: [
                { required: true, message: _ctx.$t('error.required') },
                { type: 'number', message: _ctx.$t('error.no_number') },
              ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.alertFormList.value,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.alertFormList.value) = $event)),
                                    modelModifiers: { number: true },
                                    type: "number"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["rules"]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 3 }, {
                        default: _withCtx(() => [
                          (_ctx.typeAlert === 'absolute')
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 0,
                                prop: "compositeOperator",
                                label: _ctx.$t('label.compositeOperator')
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.alertFormList.compositeOperator,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.alertFormList.compositeOperator) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.alertList.length === 0)
                                        ? (_openBlock(), _createBlock(_component_el_option, {
                                            key: 0,
                                            label: "-",
                                            value: "and"
                                          }))
                                        : _createCommentVNode("", true),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compOperList, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item,
                                          label: item,
                                          value: item
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }, 8, ["label"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, { span: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            class: "pls",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.saveAlert())),
                            circle: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      (_ctx.alertList)
                        ? (_openBlock(), _createBlock(_component_el_table, {
                            key: 0,
                            data: _ctx.alertList,
                            class: "tb",
                            "max-height": "250",
                            border: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                width: "200%",
                                prop: "samplingPoint.name",
                                label: _ctx.$t('label.monitorizationPoint'),
                                align: "center"
                              }, null, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                width: "200%",
                                prop: "parameter.name",
                                label: _ctx.$t('label.parameter'),
                                align: "center"
                              }, null, 8, ["label"]),
                              (_ctx.typeAlert === 'absolute')
                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 0,
                                    width: "100%",
                                    prop: "operator",
                                    label: _ctx.$t('label.operator'),
                                    align: "center"
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.status != false)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                            _createVNode(_component_el_select, {
                                              modelValue: scope.row.operator,
                                              "onUpdate:modelValue": ($event: any) => ((scope.row.operator) = $event),
                                              width: "50%",
                                              "value-key": "id",
                                              "destroy-on-close": ""
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operList, (item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: item,
                                                    label: item,
                                                    value: item
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["label"]))
                                : (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 1,
                                    width: "100%",
                                    prop: "operator",
                                    label: _ctx.$t('label.operator'),
                                    align: "center"
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.status != false)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                            _createVNode(_component_el_select, {
                                              modelValue: scope.row.operator,
                                              "onUpdate:modelValue": ($event: any) => ((scope.row.operator) = $event),
                                              width: "50%",
                                              "value-key": "id",
                                              "destroy-on-close": ""
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operRelative, (item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: item,
                                                    label: item,
                                                    value: item
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["label"])),
                              (_ctx.typeAlert === 'absolute')
                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 2,
                                    width: "100%",
                                    label: _ctx.$t('label.value'),
                                    align: "center"
                                  }, {
                                    default: _withCtx((scope) => [
                                      (!scope.row.status)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(scope.row.formattedValue), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            _createVNode(_component_el_input, {
                                              modelValue: scope.row.value,
                                              "onUpdate:modelValue": ($event: any) => ((scope.row.value) = $event),
                                              modelModifiers: { number: true },
                                              type: "number",
                                              size: "small"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]))
                                    ]),
                                    _: 1
                                  }, 8, ["label"]))
                                : (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 3,
                                    width: "100%",
                                    prop: "value",
                                    label: '%',
                                    align: "center"
                                  }, {
                                    default: _withCtx((scope) => [
                                      (!scope.row.status)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$n(scope.row.value, "fixed")), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            _createVNode(_component_el_input, {
                                              modelValue: scope.row.value,
                                              "onUpdate:modelValue": ($event: any) => ((scope.row.value) = $event),
                                              modelModifiers: { number: true },
                                              type: "number",
                                              size: "small"
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]))
                                    ]),
                                    _: 1
                                  })),
                              (_ctx.typeAlert === 'absolute')
                                ? (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: 4,
                                    width: "100%",
                                    prop: "compositeOperator",
                                    label: _ctx.$t('label.compositeOperator'),
                                    align: "center"
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.status != false)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _createVNode(_component_el_select, {
                                              modelValue: scope.row.compositeOperator,
                                              "onUpdate:modelValue": ($event: any) => ((scope.row.compositeOperator) = $event),
                                              width: "50%",
                                              "value-key": "id",
                                              "destroy-on-close": ""
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compOperList, (item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: item,
                                                    label: item,
                                                    value: item
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }, 8, ["label"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_el_table_column, {
                                prop: "activator",
                                label: _ctx.$t('label.operations'),
                                align: "center"
                              }, {
                                default: _withCtx((scope) => [
                                  (!scope.row.status)
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        type: "default",
                                        size: "small",
                                        onClick: ($event: any) => (_ctx.showEdit(scope.row))
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("em", {
                                            class: "el-icon el-icon-edit fas",
                                            title: _ctx.$t('btn.edit')
                                          }, null, 8, _hoisted_11)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : (_openBlock(), _createBlock(_component_el_button, {
                                        key: 1,
                                        type: "success",
                                        size: "small",
                                        onClick: ($event: any) => (_ctx.edit(scope.row))
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("em", {
                                            class: "el-icon el-icon-check fas",
                                            title: _ctx.$t('btn.activate')
                                          }, null, 8, _hoisted_12)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])),
                                  _createVNode(_component_el_button, {
                                    type: "default",
                                    size: "small",
                                    onClick: ($event: any) => (_ctx.deleteAlert(scope.row))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("em", {
                                        class: "el-icon el-icon-trash fas",
                                        title: _ctx.$t('btn.delete')
                                      }, null, 8, _hoisted_13)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }, 8, ["data"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  (_ctx.alertList)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 0,
                        span: 24
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertString, (alert, index) => {
                            return (_openBlock(), _createElementBlock("span", { key: index }, [
                              (alert.type === 'tag')
                                ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(alert.value), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(alert.value), 1))
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createVNode(_component_el_form, {
            model: _ctx.alertForm,
            "label-position": "top",
            ref: "form2",
            rules: _ctx.rules2
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_el_form_item, {
                    prop: "name",
                    label: _ctx.$t('label.name')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.alertForm.name,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.alertForm.name) = $event)),
                        width: "50%"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_el_form_item, {
                    prop: "description",
                    label: _ctx.$t('label.description')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.alertForm.description,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.alertForm.description) = $event)),
                        type: "textarea",
                        maxlength: "220",
                        rows: 2,
                        "show-word-limit": "",
                        autosize: { maxRows: 2 }
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ]),
              _createVNode(_component_el_dialog, {
                modelValue: _ctx.editAlert,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editAlert) = $event)),
                title: _ctx.$t('label.alertEdit'),
                "destroy-on-close": "",
                "custom-class": "app-form"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_alert_edit_form_component, {
                    ref: "editAlertForm",
                    item: _ctx.item
                  }, null, 8, ["item"])
                ]),
                _: 1
              }, 8, ["modelValue", "title"])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.currentView === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          (_ctx.disabledWhatsapp)
            ? (_openBlock(), _createBlock(_component_el_alert, {
                key: 0,
                type: "warning",
                description: "El envío de WhatsApp se ha desactivado temporalmente, para más información póngase en contacto con aquacorp@aquacorp.es.",
                "show-icon": "",
                closable: false
              }))
            : _createCommentVNode("", true),
          _hoisted_20,
          _createVNode(_component_el_card, {
            shadow: "never",
            class: "app-form-item",
            style: {"width":"99%"}
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_21, [
                _createTextVNode(_toDisplayString(_ctx.$t("label.shippingMethod")) + " ", 1),
                _createVNode(_component_el_tooltip, {
                  visible: _ctx.showTooltip,
                  effect: "dark",
                  content: _ctx.showTooltip ? 'Añadir contacto a la agenda' : _ctx.$t('label.contact')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "btn-method",
                      type: "primary",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openContactForm()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_22
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["visible", "content"])
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_row, {
                class: "method",
                gutter: 20
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 3 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        label: "E-mail",
                        modelValue: _ctx.alertForm.email,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.alertForm.email) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  (_ctx.alertForm.emails)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 0,
                        span: 17
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select_v2, {
                            modelValue: _ctx.alertForm.emails,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.alertForm.emails) = $event)),
                            options: _ctx.contactsEmail,
                            disabled: !_ctx.alertForm.email,
                            style: {"width":"100%"},
                            "allow-create": "",
                            filterable: "",
                            multiple: "",
                            clearable: "",
                            placeholder: " ",
                            onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.checkNewContact())),
                            "value-key": _ctx.item.label
                          }, {
                            default: _withCtx(({ item }) => [
                              _createElementVNode("span", _hoisted_23, _toDisplayString(item.label), 1),
                              _createElementVNode("span", _hoisted_24, _toDisplayString(item.value), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "options", "disabled", "value-key"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 3 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        label: "WhatsApp",
                        disabled: _ctx.checkboxDisabled,
                        modelValue: _ctx.alertForm.sms,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.alertForm.sms) = $event))
                      }, null, 8, ["disabled", "modelValue"])
                    ]),
                    _: 1
                  }),
                  (_ctx.alertForm.phoneNumbers)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 0,
                        span: 17
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select_v2, {
                            modelValue: _ctx.alertForm.phoneNumbers,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.alertForm.phoneNumbers) = $event)),
                            options: _ctx.contactsWhats,
                            disabled: !_ctx.alertForm.sms,
                            style: {"width":"100%"},
                            "allow-create": "",
                            filterable: "",
                            multiple: "",
                            clearable: "",
                            placeholder: " ",
                            onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.checkNewContactWhats())),
                            "value-key": _ctx.item.label
                          }, {
                            default: _withCtx(({ item }) => [
                              _createElementVNode("span", _hoisted_25, _toDisplayString(item.label), 1),
                              _createElementVNode("span", _hoisted_26, _toDisplayString(item.value), 1)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "options", "disabled", "value-key"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: 
            _ctx.checkboxDisabled
              ? 'Se ha superado el límite de alertas con envío por WhatsApp'
              : 'El límite de alertas con envío por WhatsApp es de ' +
                (_ctx.userData.alertCreationLimit || 0)
          
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "info",
                        size: "small",
                        circle: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_27
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["content"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_card, {
            shadow: "never",
            class: "app-form-item",
            style: {"width":"99%"}
          }, {
            header: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("label.confNotify")), 1)
            ]),
            default: _withCtx(() => [
              _hoisted_28,
              _createVNode(_component_el_radio_group, {
                disabled: 
          !(
            (_ctx.alertForm.email && _ctx.alertForm.emails && _ctx.alertForm.emails.length > 0) ||
            (_ctx.alertForm.sms && _ctx.alertForm.phoneNumbers && _ctx.alertForm.phoneNumbers.length > 0)
          )
        ,
                modelValue: _ctx.alertForm.triggers,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.alertForm.triggers) = $event)),
                onChange: _ctx.handleRadioChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: false }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("text.email_op1")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_tooltip, {
                            content: _ctx.$t('tooltip.email_op1')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "info",
                                size: "small",
                                circle: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_29
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: true }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("text.email_op2")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_tooltip, {
                            content: _ctx.$t('tooltip.email_op2')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "info",
                                size: "small",
                                circle: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_30
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disabled", "modelValue", "onChange"]),
              _createVNode(_component_el_row, { style: {"margin-top":"12px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.alertForm.timeThresholdsEnabled,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.alertForm.timeThresholdsEnabled) = $event)),
                        label: _ctx.$t('label.timeThreshold'),
                        disabled: 
              !(
                (_ctx.alertForm.email && _ctx.alertForm.emails && _ctx.alertForm.emails.length > 0) ||
                (_ctx.alertForm.sms && _ctx.alertForm.phoneNumbers && _ctx.alertForm.phoneNumbers.length > 0)
              )
            
                      }, null, 8, ["modelValue", "label", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.alertForm.timeThresholdsEnabled)
                ? (_openBlock(), _createBlock(_component_el_row, {
                    key: 0,
                    align: "middle",
                    gutter: 20,
                    style: {"margin-top":"10px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 9 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("label.startThreshold")), 1),
                            _createVNode(_component_el_input_number, {
                              size: "small",
                              modelValue: _ctx.alertForm.startThreshold,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.alertForm.startThreshold) = $event)),
                              min: 5,
                              disabled: _ctx.alertForm.triggers === undefined
                            }, null, 8, ["modelValue", "disabled"]),
                            _createVNode(_component_el_tooltip, {
                              content: _ctx.$t('tooltip.startThreshold'),
                              placement: "top"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  class: "info",
                                  size: "small",
                                  circle: ""
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_33
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["content"])
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.alertForm.triggers)
                        ? (_openBlock(), _createBlock(_component_el_col, {
                            key: 0,
                            span: 8
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("label.endThreshold")), 1),
                                _createVNode(_component_el_input_number, {
                                  size: "small",
                                  modelValue: _ctx.alertForm.endThreshold,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.alertForm.endThreshold) = $event)),
                                  min: 5
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_el_tooltip, {
                                  content: _ctx.$t('tooltip.endThreshold'),
                                  placement: "top"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      class: "info",
                                      size: "small",
                                      circle: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_36
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["content"])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : (_ctx.currentView === 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createTextVNode(" " + _toDisplayString(_ctx.alertForm.name), 1)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createTextVNode(" " + _toDisplayString(_ctx.alertForm.description), 1)
              ]),
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createTextVNode(" " + _toDisplayString(_ctx.typeAlert === "absolute" ? "Absoluta" : "Relativa"), 1)
              ]),
              (_ctx.alertForm.email)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _hoisted_47,
                    (_ctx.alertForm.emails && _ctx.alertForm.emails.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                          _createElementVNode("ul", _hoisted_49, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertForm.emails, (email, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(email), 1))
                            }), 128))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_50, "No hay correos electrónicos registrados."))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.alertForm.sms)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _hoisted_52,
                    (_ctx.alertForm.phoneNumbers && _ctx.alertForm.phoneNumbers.length > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_53, [
                          _createElementVNode("ul", _hoisted_54, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alertForm.phoneNumbers, (number, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(number.startsWith("34") ? number.substring(2) : number), 1))
                            }), 128))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_55, "No hay números registrados."))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.alertForm.email || _ctx.alertForm.sms)
                ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _hoisted_57,
                    _createTextVNode(" " + _toDisplayString(_ctx.triggers.eventTriggered
            ? "Se enviará una notificación cada vez que se cumplan las condiciones configuradas en esta alerta."
            : "Se enviará una notificación cuando se cumplan las condiciones configuradas en esta alerta y otra notificación cuando se dejen de cumplir dichas condiciones."), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_58,
            _createVNode(_component_el_table, {
              data: _ctx.alertList,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "Punto de monitorización",
                  prop: "samplingPoint.name"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Parámetro",
                  prop: "parameter.name"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Operador",
                  prop: "operator"
                }),
                _createVNode(_component_el_table_column, {
                  label: "Valor",
                  prop: "value"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(_ctx.$n(scope.row.value, "fixed")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Operador Compuesto",
                  prop: "compositeOperator"
                })
              ]),
              _: 1
            }, 8, ["data"])
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showContactForm,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.showContactForm) = $event)),
      title: _ctx.$t('label.contactForm'),
      "destroy-on-close": "",
      class: "dialog-contact",
      "custom-class": "app-form"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_contact_form_component, { ref: "contactForm" }, null, 512),
        _createElementVNode("div", _hoisted_59, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.closeContactForm()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.saveChanges()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}